import React from 'react'
import { 
  RootContainer, 
  Spin, 
  SpinTextContainer,
  Button, 
  FirstText,
  SecText
} from './GoToSpin.style';
import { useTranslation } from 'react-i18next';
import { ENGLISH_LANGUAGE_CODE_LK, BURMESE_LANGUAGE_CODE_LK } from '@constants'
import { localStorage } from '@utils';
import { PUBLIC_ROUTE } from "@router/route.constants";
import { useNavigate } from 'react-router-dom';

const GoToSpin = () => {
  const { t } = useTranslation();
  const userPreferedLanguage = localStorage.getUserPreferedLanguage();
  const navigate = useNavigate();
  
  const handleSpinClicked = () => {
    navigate(`/${PUBLIC_ROUTE.SPIN_HOME}`);
  }

  return (
    <RootContainer>
      <Spin />
      <SpinTextContainer>
        <FirstText
          burmese={userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK ? 'true' : 'false'}
        >
          {t("home.spinBtnText").split('&')[0]} 
          {userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK && '&'}
        </FirstText>
        <SecText
          burmese={userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK ? 'true' : 'false'}
        >{t("home.spinBtnText").split('&')[1]}</SecText>
      </SpinTextContainer>
      <Button onClick={handleSpinClicked}> {t("home.play")} </Button>
    </RootContainer>
  )
}

export default GoToSpin;